module.exports = __webpack_public_path__ + "media/images/icons/outlined/arrow-left-3c98d7bd7f789ec9f8819f5e79bc395b.svg";